import React, { useContext } from "react"

import PropTypes from "prop-types"
import { View, Text } from "react-native"
import { connect } from "react-redux"

import { setIsCalendarSynchronized } from "@actions/calendarActions"
import {
  handleCloseSuggestion,
  showSuggestionListFooter,
  setSideBarContent,
} from "@actions/commonActions"
import CalendarCard from "@components/calendarCard"
import { selectUserInfo } from "@selectors/user"
import TabView from "@ui/tabViewGameplan"
import ViewWithHeader from "@ui/viewWithHeader"
import { SCREENS } from "@utils/calendarUtils"
import { GAMEPLAN_OPTIONS } from "@utils/gamePlanUtils"

import { TimeWheelContext } from "../../contexts/TimeWheelContext"
import { selectBeforeCalendarDate } from "../../selectors/calendar"
import RecommendationList from "../gamePlansCard/RecommendationList"

import { GameplanStyles } from "./createTeeupStyles"

import "./index.scss"

const KeyboardAvoidingScrollView = ({ isWhere, children }) => {
  if (!isWhere)
    return (
      <View style={[GameplanStyles.flex, GameplanStyles.mainContainer]}>
        {children}
      </View>
    )

  return (
    <View
      style={GameplanStyles.flex}
      contentContainerStyle={GameplanStyles.whereContent}>
      {children}
    </View>
  )
}

KeyboardAvoidingScrollView.propTypes = {
  isWhere: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
}

const GameplanView = props => {
  let {
    title,
    renderedFields,
    type,
    isTemporalCustom,
    suggestion,
    routes,
    onIndexChange,
    isTimeZoneEnabled,
    recommendations,
    onSubmit,
    canSubmit,
    renderScene,
    isNew,
    componentId,
    contentHeight,
    isCalendarShown,
    onCloseCalendarCard,
    startDate,
    passedEvent,
    onDatesSelected,
    duration,
    sceneIndex,
    tabViewRef,
    isFromCreateTeeup,
    content,
    isModalOpened,
    closeSuggestions,
    layout,
    handleCloseSuggestion,
    showSuggestionListFooter,
    setSideBarContent,
    isBeforeCalendarDate,
    userInfo,
    setIsCalendarSynchronized,
  } = props
  const isWhen = type === GAMEPLAN_OPTIONS.when
  const isWhere = type === GAMEPLAN_OPTIONS.where

  let renderedContent = (
    <View style={[GameplanStyles.containerWhat]}>
      <View style={GameplanStyles.fieldsContainer}>{renderedFields}</View>
    </View>
  )

  if (isWhen) {
    renderedContent = (
      <TabView
        ref={tabViewRef}
        routes={routes}
        renderScene={renderScene}
        onTabIndexChange={onIndexChange}
        initialTabIndex={sceneIndex}
        isTemporalCustom={isTemporalCustom}
        // titles={["Specific Date?"]}
        scrollEnabled
        customTabbarStyle={GameplanStyles.tabbarStyle}
        customTabbarWrapperStyle={GameplanStyles.tabbarStyle}
      />
    )
  }

  if (isWhere) {
    renderedContent = (
      <>
        <TabView
          ref={tabViewRef}
          routes={routes}
          renderScene={renderScene}
          onTabIndexChange={onIndexChange}
          initialTabIndex={sceneIndex}
          scrollEnabled
          customTabbarStyle={GameplanStyles.tabbarStyle}
          customTabbarWrapperStyle={GameplanStyles.tabbarStyle}
        />
        {recommendations && recommendations.length > 0 && (
          <View style={GameplanStyles.recommendationsContainer}>
            <Text style={GameplanStyles.recommendationsTitle}>
              Recommended for Where
            </Text>
            <RecommendationList recommendations={recommendations} />
          </View>
        )}
      </>
    )
  }

  const { isDisabledDate, onSuggestSubmit } = useContext(TimeWheelContext)
  const isSubmitDisabled = () => !canSubmit || isDisabledDate

  return (
    <>
      {isModalOpened && (
        <div
          className="settings__modal settings__modal-content"
          style={{ animation: "none", width: "100%" }}>
          {content}
        </div>
      )}
      <ViewWithHeader
        headerStyle={GameplanStyles.header}
        title={`Suggest ${title}`}
        isFromCreateTeeup={isFromCreateTeeup}
        isTemporalCustom={isTemporalCustom}
        containerStyle={{
          flex: 0,
          height: "100%",
          minHeight: "300px",
          maxHeight: isModalOpened ? "50vh" : "75vh",
          overflow: "hidden",
        }}
        onCancel={closeSuggestions}
        isWhen>
        <KeyboardAvoidingScrollView isWhere={isWhere}>
          <View style={GameplanStyles.flex}>{renderedContent}</View>

          <div
            className="footer-buttons__wrapper"
            style={{ marginTop: isWhere ? "83%" : 0 }}>
            <button
              data-testid="decideOnThisButton"
              className={
                isSubmitDisabled()
                  ? "footer-buttons__place footer-button__place-disabled"
                  : "footer-buttons__place"
              }
              disabled={isSubmitDisabled()}
              onClick={() => {
                onSuggestSubmit(true)
                handleCloseSuggestion()
                showSuggestionListFooter()
                setSideBarContent([])
                // TODO: remove it later (Calendar removing)
                // setIsCalendarSynchronized(false)
                // syncCalendar()
              }}>
              Decide on this
            </button>
            <button
              className={
                isSubmitDisabled()
                  ? "footer-button__disabled"
                  : "footer-buttons__suggest"
              }
              data-testid="suggestButton"
              disabled={isSubmitDisabled()}
              onClick={() => {
                onSuggestSubmit(false)
                handleCloseSuggestion()
                showSuggestionListFooter()
                setSideBarContent([])
              }}>
              Suggest
            </button>
          </div>

          {sceneIndex === 0 && layout && (
            <div
              className={`${
                isFromCreateTeeup ? `addContact__fromCreateTeeup` : `addContact`
              }`}>
              <div
                className={`${
                  isFromCreateTeeup
                    ? `addContact__content__fromCreateTeeup`
                    : `addContact__content`
                }`}
                style={{ paddingBottom: 15 }}>
                {layout}
              </div>
            </div>
          )}
        </KeyboardAvoidingScrollView>
      </ViewWithHeader>
      {contentHeight && isWhen && (
        <CalendarCard
          newSuggestionProps={{
            duration,
            passedEvent,
            selectedDate: startDate,
            onDatesSelected,
            isFromCreateTeeup,
          }}
          contentHeight={contentHeight}
          parentComponentId={componentId}
          isCalendarShown={isCalendarShown}
          onCloseCalendarCard={onCloseCalendarCard}
          activeScreen={SCREENS.day}
        />
      )}
    </>
  )
}

GameplanView.propTypes = {
  title: PropTypes.string,
  fields: PropTypes.array,
  onPress: PropTypes.func,
  renderedFields: PropTypes.array,
  type: PropTypes.string,
  duration: PropTypes.number,
  suggestion: PropTypes.object,
  routes: PropTypes.array,
  onIndexChange: PropTypes.func,
  onDatesSelected: PropTypes.func.isRequired,
  isTimeZoneEnabled: PropTypes.bool,
  isCalendarShown: PropTypes.bool,
  recommendations: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  componentId: PropTypes.string,
  sceneMapping: PropTypes.object,
  passedEvent: PropTypes.object,
  renderScene: PropTypes.func,
  startDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  startDateIndex: PropTypes.number,
  endDateIndex: PropTypes.number,
  sceneIndex: PropTypes.number,
  contentHeight: PropTypes.number,
  onCalendar: PropTypes.func,
  onCloseCalendarCard: PropTypes.func,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func.isRequired,
  // canSubmit: PropTypes.bool.isRequired,
  isCustomDate: PropTypes.bool,
  allowPutOnGameplan: PropTypes.bool,
  onToggleAddingToGameplan: PropTypes.func,
  onScreenPress: PropTypes.func,
  onLayout: PropTypes.func.isRequired,
  selected: PropTypes.bool,
  isNew: PropTypes.bool,
  isFromCreateTeeup: PropTypes.bool,
  tabViewRef: PropTypes.func,
  isBeforeCalendarDate: PropTypes.bool,
}

const mapStateToProps = state => {
  return {
    isBeforeCalendarDate: selectBeforeCalendarDate(state),
    userInfo: selectUserInfo(state),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setIsCalendarSynchronized: isCalendarSynchronized =>
      dispatch(setIsCalendarSynchronized(isCalendarSynchronized)),
    handleCloseSuggestion: () => dispatch(handleCloseSuggestion()),
    showSuggestionListFooter: () => dispatch(showSuggestionListFooter()),
    setSideBarContent: () => dispatch(setSideBarContent()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(GameplanView)
